<div class="profile-content-section" data-cy="reputation-score-area">
  <h2 data-cy="reputation-score-title">Reputation Score</h2>

  <ng-container *ngIf="reputationScore && reputationScore.reputationScore; else noReputationScore">
    <div class="reputation-score-container">
      <div class="flex flex-col justify-content-start align-items-start" style="gap: 40px;">
        <div>
          <span>Based on {{installer.firstName}}'s </span><span style="font-weight: bold;">{{getCompletedProjectReviews()}}</span><span> completed project reviews.</span>
        </div>
        <div class="flex flex-row justify-content-center align-items-center" style="width: 100%;">
          <div style="width: 300px;">
            <ion-range class="reputation-score-range disabled" min="0" max="100" bar="grey" [value]="getScore()"
              style="padding: 0; margin: 20px 0;"></ion-range>
            <div style="font-size: 20px; font-weight: bold; text-align: center; margin-top: 20px;">{{getScore()}}%</div>
          </div>
        </div>
        <div class="ion-text-center">
          <span>{{installer.firstName}} has received the most positive feedback on his dependability and exceptional quality.</span>
        </div>
      </div>

      <div class="flex flex-col justify-content-start align-items-center" style="gap: 50px;">
        <div class="radar-chart-wrapper">
          <div class="radar-chart">
            <div id="kudosReasonsRadarChart1" data-cy="kudos-radar-chart"></div>
          </div>
        </div>
        <div class="ion-text-center">
          <span>Numbers reflect average rating (1-10) across 7 core completed project performance metrics.</span>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #noReputationScore>
    <div class="alert alert__warning text-center" data-cy="empty-reputation-score">
      No Reputation Score found for this installer.
    </div>
  </ng-template>
</div>
